import orderDataSelectorDefinition from './order-data'
import isUnsupportedInJurisdictionSelectorDefinition from './is-unsupported-in-jurisdiction'
import loadedSelectorDefinition from './loaded'
import lastFailedOrderSelectorDefinition from './last-failed-order'
import visibleOrdersSelectorDefinition from './visible-orders'
import isBuySupportedInCountrySelectorDefinition from './is-buy-supported-in-country'
import getHasZeroFeesSelectorDefinition from './get-has-zero-fees'
import groupedAssetsSelectorDefinition from './grouped-assets'
import completedOrdersSelectorDefinition from './completed-orders'
import countrySelectorDefinition from './country'
import countryDataSelectorDefinition from './country-data'
import createCryptoAssetsFromOrderTypeSelectorDefinition from './create-crypto-assets-from-order-type'
import createVisibleOrdersByTypeSelectorDefinition from './create-visible-orders-by-type'
import cryptoAssetsSelectorDefinition from './crypto-assets'
import fiatAssetsSelectorDefinition from './fiat-assets'
import assetDataSelectorDefinition from './asset-data'
import getAvailableSellBalanceSelectorDefinition from './get-available-sell-balance'
import configDataSelectorDefinition from './config-data'
import isEnabledSelectorDefinition from './is-enabled'
import isZeroFeesEnabledForAssetSelectorDefinition from './is-zero-fees-enabled-for-asset'
import providerConfigSelectorDefinition from './provider-config'
import getProviderAvailabilitySelectorDefinition from './get-provider-availability'
import isOnSelectorDefinition from './is-on'
import inProgressOrdersSelectorDefinition from './in-progress-orders'
import createInProgressPurchasesCountMapSelectorDefinition from './create-in-progress-purchases-count-map'
import getIsAssetIntersectionByOrderTypeSelectorDefinition from './get-is-asset-intersection-by-order-type'
import isAssetBuyIntersectionSelectorDefinition from './is-asset-buy-intersection'
import isAssetSellIntersectionSelectorDefinition from './is-asset-sell-intersection'
import isAssetSupportedByOrderTypeSelectorDefinition from './is-asset-supported-by-order-type'
import isBuySupportedByAssetSelectorDefinition from './is-buy-supported-by-asset'
import isSellSupportedByAssetSelectorDefinition from './is-sell-supported-by-asset'
import testnetAssetsSelectorDefinition from './testnet-assets'

const fiatRampSelectors = [
  assetDataSelectorDefinition,
  completedOrdersSelectorDefinition,
  configDataSelectorDefinition,
  countryDataSelectorDefinition,
  countrySelectorDefinition,
  createCryptoAssetsFromOrderTypeSelectorDefinition,
  createVisibleOrdersByTypeSelectorDefinition,
  createInProgressPurchasesCountMapSelectorDefinition,
  cryptoAssetsSelectorDefinition,
  fiatAssetsSelectorDefinition,
  getAvailableSellBalanceSelectorDefinition,
  getHasZeroFeesSelectorDefinition,
  getProviderAvailabilitySelectorDefinition,
  groupedAssetsSelectorDefinition,
  getIsAssetIntersectionByOrderTypeSelectorDefinition,
  isAssetSupportedByOrderTypeSelectorDefinition,
  isAssetBuyIntersectionSelectorDefinition,
  isAssetSellIntersectionSelectorDefinition,
  isBuySupportedByAssetSelectorDefinition,
  isBuySupportedInCountrySelectorDefinition,
  isEnabledSelectorDefinition,
  isOnSelectorDefinition,
  isSellSupportedByAssetSelectorDefinition,
  isZeroFeesEnabledForAssetSelectorDefinition,
  providerConfigSelectorDefinition,
  inProgressOrdersSelectorDefinition,
  isUnsupportedInJurisdictionSelectorDefinition,
  testnetAssetsSelectorDefinition,
  lastFailedOrderSelectorDefinition,
  loadedSelectorDefinition,
  orderDataSelectorDefinition,
  visibleOrdersSelectorDefinition,
]

export default fiatRampSelectors
